module.exports = __webpack_public_path__ + "static/1043179154.39b75a43.jpg";